export const ApplicationName = 'codai';

export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message'
};

const prefix = '/authentication';

export const ApplicationPaths = {
  DefaultLoginRedirectPath: '/',
  ApiAuthorizationPrefix: prefix,
  Profile: `${prefix}/profile`,
  Login: `${prefix}/login`,
  LoginCallback: `${prefix}/login-callback`,
  LogOut: `${prefix}/logout`,
  LogOutCallback: `${prefix}/logout-callback`,
};
